import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import './styles/globals.scss';
import App from './App';
import ScrollToTop from './components/_shared/ScrollToTop/ScrollToTop';
import SubscriptionProvider from './features/subscription/SubscriptionProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60, // 1 hour
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <SubscriptionProvider>
        <ScrollToTop />
        <App />
      </SubscriptionProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
